export default {
	data() {
		return {
			pageWidth: null,
			minWidth: 767,
		}
	},
	computed: {
		responsive() {
			return this.pageWidth <= this.minWidth
		},
	},
	methods: {
		onScreenResize() {
			this.pageWidth = window.innerWidth
		},
	},
	created() {
		window.addEventListener('resize', this.onScreenResize)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onScreenResize)
	},
	mounted() {
		this.$nextTick(() => this.onScreenResize())
	},
}
